import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";
import { formatNumberWithCommas } from "app/pages/sales-intelligence/utils/numbers";

import { StyledLink } from "./styles";

type Props = {
    quota: number;
    url: string;
    className?: string;
};

const QuotaLeftLink = ({ quota, url, className }: Props) => {
    const { translate } = useTranslate();

    const creditsLeftKey = quotaKeys.creditsLeft({ quota: formatNumberWithCommas(quota) });

    return (
        <Flex
            className={className}
            gap="12px"
        >
            <Flex gap="4px">
                <SWReactIcons
                    iconName="spend"
                    size="16px"
                    iconColor={colorsPalettes.midnight[400]}
                />
                <Text
                    fontVariant="listItem3"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate(creditsLeftKey.key, creditsLeftKey.replacements)}
                </Text>
            </Flex>

            <StyledLink
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-automation="quota-left-link"
            >
                <SWReactIcons
                    iconName="link-out"
                    iconColor={colorsPalettes.carbon[300]}
                    size="16px"
                />
            </StyledLink>
        </Flex>
    );
};

export default QuotaLeftLink;
